import axios from 'axios'
const http = axios.create({
  baseURL: 'https://www.airdaas.com'
})

http.interceptors.response.use(function (response) {
  var res = response.status
  if (res !== 200) {
    throw new Error('网络出问题了请稍后再试')
  }
  var code = response.data.meta.code
  var str = ''
  switch (code) {
    case 50001:
      str = '用户名或密码不正确'
      throw new Error(str)
    case 50002:
      str = '该ip超过当日请求次数'
      throw new Error(str)
    case 50003:
      str = 'sign未通过验证'
      break
    case 50004:
      str = '用户名未填'
      break
    case 50005:
      str = '密码未填'
      throw new Error(str)
    case 50006:
      str = '提交时间未填证'
      break
    case 50007:
      str = '请求超时'
      throw new Error(str)
    case 50008:
      str = 'sign未填'
      break
    case 50009:
      str = '该ip今日请求次数已达到上限'
      throw new Error(str)
    case 50010:
      str = '系统异常'
      throw new Error(str)
    case 50011:
      str = '刷新'
      window.localStorage.removeItem('token')
      break
    case 50012:
      str = '用户信息错误 请重新登录'
      window.localStorage.removeItem('token')
      throw new Error(str)
    case 50013:
      str = 'page不为数字'
      break
    case 50014:
      str = 'limit不为数字'
      break
    case 50015:
      str = 'device_code为空'
      break
    case 50016:
      str = 'min_time输入有误'
      break
    case 50017:
      str = 'max_time输入有误'
      break
    case 50018:
      str = '时间范围有误'
      break
    case 50019:
      str = 'parameter参数不在范围内'
      break
    case 50020:
      str = '该设备不属于你'
      throw new Error(str)
    case 50021:
      str = 'refresh_token有误'
      break
    case 50022:
      str = '账号不存在'
      throw new Error(str)
    case 50023:
      str = 'id目未填'
      break
    case 50024:
      str = 'area_id不为数字'
      break
    case 50025:
      str = 'area_id未填'
      break
    case 50026:
      str = 'project_id不为数字'
      break
    case 50027:
      str = 'name不为中文'
      break
    case 50028:
      str = 'code不正确'
      break
    case 50029:
      str = 'address不正确'
      throw new Error(str)
    case 50030:
      str = 'id不为数字'
      throw new Error(str)
    case 50031:
      str = 'area不存在'
      throw new Error(str)
    case 50032:
      str = 'color不正确'
      break
    case 50033:
      str = 'device_id不为设备识别号'
      break
    case 50034:
      str = '设备名称不为中文'
      throw new Error(str)
    case 50035:
      str = 'devicebrand_id不为数字'
      break
    case 50036:
      str = 'type不为数字'
      break
  }
  return response
}, function (error) {
  return Promise.reject(error)
})

export default http
